import { createConnectTransport, createGrpcWebTransport } from "@connectrpc/connect-web";
import { Platform } from "react-native";
import Config from "react-native-config";
import {
  SMG_SERVER_URL,
  SMG_PARTNER_URL,
  SMG_BAY_SESSION_URL,
} from "react-native-dotenv";

const smgBaseUrl = Config.SMG_SERVER_URL || SMG_SERVER_URL || "";
const partnerBaseUrl = Config.SMG_PARTNER_URL || SMG_PARTNER_URL || smgBaseUrl;
// bay-session service (Connect/gRPC on :9100 by default). Falls back to the
// SMG core URL so deployments behind a single gateway still function; local
// Tilt setups must set SMG_BAY_SESSION_URL explicitly because the cluster
// exposes bay-session on a distinct port.
const baySessionBaseUrl = Config.SMG_BAY_SESSION_URL || SMG_BAY_SESSION_URL || smgBaseUrl;

/**
 * React Native lacks a browser-compatible ReadableStream implementation, so
 * the grpc-web framing transport is required on native. Web and Tauri targets
 * can use the full Connect protocol over HTTP/1.1 fetch.
 */
function makeTransport(baseUrl: string) {
  if (Platform.OS === "web") {
    return createConnectTransport({ baseUrl });
  }
  return createGrpcWebTransport({ baseUrl });
}

export const smgTransport = makeTransport(smgBaseUrl);
export const partnerTransport = makeTransport(partnerBaseUrl);
export const baySessionTransport = makeTransport(baySessionBaseUrl);
